import React from 'react';

/**
 * TagList renders a row of wrap-around badge items (e.g. project tech tags or skills).
 */
export const TagList = ({ tags = [], style = {} }) => {
  if (!tags || tags.length === 0) return null;
  return (
    <div 
      className="block-tag-list" 
      style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '4px 8px', 
        marginTop: '6px',
        ...style 
      }}
    >
      {tags.map((tag, idx) => {
        const text = typeof tag === 'string' ? tag : (tag.name || tag.value || '');
        if (!text) return null;
        return (
          <span 
            key={idx} 
            style={{ 
              fontSize: 'var(--font-size-label, 8pt)',
              color: 'var(--color-text-light, #7F8C8D)',
              padding: '2px 6px',
              border: '1px solid var(--color-border, #BDC3C7)',
              borderRadius: '4px',
              backgroundColor: 'var(--color-bg-page, #ffffff)'
            }}
          >
            {text}
          </span>
        );
      })}
    </div>
  );
};
export default TagList;
